
  import { defineComponent } from 'vue';

  import StatisticsBaseSwitchTab from './StatisticsBaseSwitchTab.vue';

  export default defineComponent({
    name: 'StatisticsByTimeTabs',
    components: {
      StatisticsBaseSwitchTab,
    },
  });
